import { render } from "./Loader.vue?vue&type=template&id=c7bd7f80&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=c7bd7f80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7bd7f80"]])

export default __exports__